/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Grid, Icon, Popup } from 'semantic-ui-react';
import { SearchBar, USER_PERMISSIONS, PRODUCT_PERMISSIONS } from 'dyl-components';
import { useDispatch, useSelector } from 'react-redux';
import leadIngest from 'actions/lead_ingestion';

import { CardData, CardDataItem } from 'shared/CardData';
import { StringUtils } from 'utils';
import RestrictedView from 'shared/RestrictedView';

export const DataProvidersToolbar = ({ isSearching, onSearch, search, setSearch, onChangeSearch }) => {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const dispatch = useDispatch();

    const leadEmail = useSelector(state => { return state.lead_ingestion.lead_email || 'N/A' } );
    const isReadingLeadProviderLimits = useSelector(state => state.lead_ingestion.isReadingLeadProviderLimits);
    const cancelFunction = () => {
        const query = new URLSearchParams(params);
        query.delete('search');
        setSearch('');
        const query_string = query.toString();
        navigate(`/settings/data-providers${query_string ? `?${query_string}` : ''}`,);
    };

    useEffect(() => {
        dispatch(leadIngest.leadIngestionEmail())
    }, [dispatch]);

    useEffect(() => {
        dispatch(leadIngest.getProductLimits());
    }, [dispatch]);

    return (
        <React.Fragment>
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <div className='DataProviders__info'>
                            <div>
                                <CardData>
                                    <CardDataItem>
                                        <strong>Email</strong>&nbsp;[<a>{leadEmail}</a>]  <Popup
                                            trigger={(
                                                <Icon
                                                    link
                                                    className="fas fa-copy"
                                                    style={{ margin: '0 5px' }}
                                                    onClick={StringUtils.copy(
                                                        leadEmail
                                                    )}
                                                    color="primary"
                                                />
                                            )}
                                            content='Copied!'
                                            on='click'
                                            closeOnTriggerMouseLeave
                                            inverted
                                        />{" "}
                                    </CardDataItem>
                                </CardData>
                            </div>
                            <div style={{ marginLeft: '1em', marginRight: '0.1em' }}>
                                <CardData>
                                    <CardDataItem>
                                        <Icon style={{ margin: '0 5px' }} className='fas fa-exclamation-triangle' /> <strong>Rejected: </strong>&nbsp;0
                                    </CardDataItem>
                                    <CardDataItem>
                                        <Icon style={{ margin: '0 5px' }} className='fas fa-diagram-project' /> <strong>Partially Accepted: </strong>&nbsp;0
                                    </CardDataItem>
                                </CardData>
                            </div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <div className='DataProvidersToolbar'>
                            <SearchBar
                                isSearching={isSearching}
                                search={search}
                                searchFcn={onSearch}
                                cancelFcn={cancelFunction}
                                placeholder={'Search by Provider Name'}
                                onChange={onChangeSearch}
                                bottomError
                            />
                            <RestrictedView type='disabled' productPermission={PRODUCT_PERMISSIONS.SETTINGS_DATA_PROVIDERS} userPermission={USER_PERMISSIONS.DATA_PROVIDERS_ADD}>
                            <Button primary as={Link} to="/settings/data-providers/create" disabled={isReadingLeadProviderLimits} className='DataProvidersToolbar__NewDataProviderButton'>
                                <Icon name='plus' /> New Data Provider
                            </Button>
                            </RestrictedView>
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </React.Fragment>
    )
}
